import './style.css';
import { createApp } from './main';
import { router } from './router';

(async () => {
  const { app } = createApp();

  // application.ts registers the global pricing / lab-loading watchers (shopsV10Params →
  // fetchShopsAndCount, costing, taxes) and restores selectedLabs, all as import
  // side-effects. It used to be pulled in only by QuoteEdit/LabCard, so entering directly
  // on another page (e.g. the login/ticket redirect landing on /quote/summary/shipping)
  // left the whole pipeline inert: labs never load and the price never computes. Import it
  // here — after pinia is installed (so its module-level useStore() calls resolve) and
  // before mount (so the non-immediate watchers are registered before any page's onMounted
  // fetches the cart and changes the params they watch).
  await import('./application');

  await router.isReady();

  app.mount('#app');
})();
